import { selectionsOrdering } from "../../constants";
export const findSelectionsOrdering = (template, outcomeType) => {
    let orderMap = selectionsOrdering[template];
    return outcomeType && Object.keys(orderMap).filter(key => {
        return orderMap[key].find(val => {
            return val === outcomeType && key;
        });
    }).shift() || "0";
};
//# sourceMappingURL=findSelectionsOrdering.js.map